<template>
    <div class="grid grid-cols-12 base-responsive-gap lg:gap-y-4" style="grid-template-rows: auto 1fr">
        <div
            class="col-span-12 separator-border-top-line"
            :class="imgOrientationPortrait ? 'lg:col-span-6 lg:col-start-6' : 'lg:col-span-4 lg:col-start-8'"
        >
            <h2 class="header-2"><T :t="titleKey" /></h2>
        </div>

        <div
            class="col-span-12 lg:col-start-2 lg:row-span-2 lg:row-start-1"
            :class="imgOrientationPortrait ? 'lg:col-span-4' : 'lg:col-span-6'"
        >
            <StaticImage
                :img-key="staticImageKey"
                :wrapper-class="`relative base-responsive-rounding ${
                    imgOrientationPortrait ? 'aspect-w-4 aspect-h-5' : 'aspect-w-3 aspect-h-2'
                }`"
                image-class="w-full h-full object-cover base-responsive-rounding"
            />
        </div>

        <div class="col-span-12" :class="imgOrientationPortrait ? 'lg:col-span-6' : 'lg:col-span-4'">
            <div class="whitespace-pre-line">
                <T :t="descriptionKey" />
            </div>

            <Button
                v-if="buttonUrl && !/button_url/.test(buttonUrl)"
                :to="buttonUrl"
                target="_blank"
                class="mt-8"
                :label="$t(buttonLabelKey)"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Type9Block',
    props: {
        titleKey: {
            type: String,
            required: true,
        },
        descriptionKey: {
            type: String,
            required: true,
        },
        staticImageKey: {
            type: String,
            required: true,
        },
        buttonLabelKey: {
            type: String,
            required: false,
            default: null,
        },
        buttonUrl: {
            type: String,
            required: false,
            default: null,
        },
        imgOrientationPortrait: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>

<style scoped></style>
